export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-alteracao-consultas-finalizadas' */ '@/views/ambulatorio/alteracao-consultas-finalizadas/Index'),
        path: 'alteracao-consultas-finalizadas',
        redirect: 'alteracao-consultas-finalizadas/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-alteracao-consultas-finalizadas' */'@/views/ambulatorio/alteracao-consultas-finalizadas/List.vue'),
                name: 'ambulatorio-alteracao-consultas-finalizadas-index',
                path: 'index',
            },
        ],
    },

]